import { Amplify } from 'aws-amplify';
import { generateClient } from 'aws-amplify/api';
import { I18n, parseAmplifyConfig } from 'aws-amplify/utils';
import awsmobile from './aws-exports';
import { AuthLabels } from './components/homepage/auth-theme';

// v6 configures from a ResourcesConfig rather than the flat aws-exports shape.
// parseAmplifyConfig translates the generated file for us, so aws-exports.js
// stays byte-for-byte what the Amplify CLI writes -- it carries a DO NOT EDIT
// banner and is regenerated on every `amplify pull`.
//
// The identity pool is dropped. With one configured, v6's fetchAuthSession()
// -- which every client.graphql call awaits -- also fetches IAM credentials
// (GetId + GetCredentialsForIdentity), and concurrent calls each do it. That
// put six Cognito Identity round trips in front of the first box query. v3
// never touched the identity pool, and nothing here needs IAM credentials:
// AppSync uses user-pool auth and Flask verifies the user-pool token.
const parsed = parseAmplifyConfig(awsmobile);
// eslint-disable-next-line no-unused-vars
const { identityPoolId, allowGuestAccess, ...cognito } = parsed.Auth.Cognito;
export const amplifyConfig = {
  ...parsed,
  Auth: { ...parsed.Auth, Cognito: cognito },
};
Amplify.configure(amplifyConfig);

// The sign-in / sign-up forms read their copy through I18n, and this used to
// run inside a UserProvider effect -- i.e. after the first render, so the forms
// briefly showed the untranslated defaults. Setting it here means the
// vocabulary is in place before any component mounts.
I18n.setLanguage('en');
I18n.putVocabularies(AuthLabels);

// v6 replaces the `API` singleton with a client you generate once and reuse.
// Generating one per call site would rebuild the AppSync auth plumbing each
// time, so the whole app shares this instance.
export const client = generateClient();
